const n=({children:e})=>e;export{n as Then};
